import { Component, OnInit, ViewChild } from '@angular/core';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { O2PortalAsuSmrReportService } from "../o2-portal-asu-smr-report.service";
import { DxSelectBoxComponent, DxTagBoxComponent } from 'devextreme-angular';
import { AsuSmrChartsComponent } from "../asu-smr-charts/asu-smr-charts.component";
import { AsuSmrDetailsComponent } from "../asu-smr-details/asu-smr-details.component";
import { AsuSmrReportFilters } from "../types/AsuSmrReportFilters";

@Component({
  selector: 'app-asu-smr-filters',
  templateUrl: './asu-smr-filters.component.html',
  styleUrls: ['./asu-smr-filters.component.scss']
})
export class AsuSmrFiltersComponent implements OnInit {
  smrAndAsuAwardsReportFilterData: any[];
  countryDataSource: any[];
  awardYears: any[];
  selectedStartAwardYear: string = '2000';
  selectedEndAwardYear: string = (new Date()).getFullYear().toString();
  manufacturerDataSource: any[];
  statusDataSource: any[];
  competitorDataSource: any[];
  segmentDataSource: any[];
  selectedSegment: any[];
  selectedCountryResult: string;
  provinceDataSource: any;
  selectedStatus: any[] = ['Operational', 'Planned', 'Under construction'];
  gasDataSource: any[];
  selectedCompetitor: any;
  reportDataSource: any[];
  asuHycoInvestmentDataResponse: any[];
  isLoadPanelVisible: boolean = true;
  selectedReportLinkId: number = 1;
  asuAndHYCOInvestmentFilters: AsuSmrReportFilters;
  viewReports: boolean = false;
  @ViewChild(AsuSmrChartsComponent) asuSmrChartsComponent: AsuSmrChartsComponent
  @ViewChild(AsuSmrDetailsComponent) asuSmrDetailsComponent: AsuSmrDetailsComponent
  @ViewChild("status", { static: false }) status: DxTagBoxComponent;
  @ViewChild("competitors", { static: false }) competitors: DxTagBoxComponent;
  @ViewChild("segments", { static: false }) segments: DxTagBoxComponent;
  @ViewChild("startAwardYear", { static: false }) startAwardYear: DxSelectBoxComponent;
  @ViewChild("endAwardYear", { static: false }) endAwardYear: DxSelectBoxComponent;

  constructor(private notificationService: NotificationService,
    private o2PortalAsuSmrReportService: O2PortalAsuSmrReportService) {
  }

  ngOnInit(): void {
    this.awardYears = this.o2PortalAsuSmrReportService.getAwardYears();
    this.getReportsData();
  }

  getReportsData() {
    this.o2PortalAsuSmrReportService.getAsuManufacturerReportData().subscribe({
      next: tgeeProspectsChemicalsOtherDataList => {
        this.asuHycoInvestmentDataResponse = tgeeProspectsChemicalsOtherDataList;
        this.statusDataSource = this.asuHycoInvestmentDataResponse.map((item) => item.status).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);;
        this.competitorDataSource = this.asuHycoInvestmentDataResponse.map((item) => item.competitor).filter((value, index, self) => value && (self.indexOf(value) === index)).sort((a, b) => a > b ? 1 : -1);;
        this.segmentDataSource = this.asuHycoInvestmentDataResponse.map((item) => item.segment).filter((value, index, self) => self.indexOf(value) === index).sort((a, b) => a > b ? 1 : -1);;
        this.isLoadPanelVisible = false;
        this.selectedSegment = this.segmentDataSource;
      }, error: (error: any) => {
        this.isLoadPanelVisible = false;
        this.notificationService.alert("error", "Error while fetching GlobalASUForecastReport data", error);
      }
    });
  }

  renderReport(e) {
    var linkId = e.itemIndex + 1;
    // if NOT same linked clicked then only reder/load report component 
    if (this.selectedReportLinkId != linkId) {
      this.selectedReportLinkId = linkId;
      if (e.itemIndex === 1) {
        this.asuSmrChartsComponent.getASUAndHYCOInvestmentReportData(this.asuAndHYCOInvestmentFilters);
      } else if (e.itemIndex === 0) {
        this.asuSmrDetailsComponent.getASUAndHYCOInvestmentDetailsReportData(this.asuAndHYCOInvestmentFilters);
      }
    }
  }

  viewReport() {
    this.viewReports = true;
    if (!this.selectedStatus || this.selectedStatus.length <= 0 || !this.selectedCompetitor
      || this.selectedCompetitor.length <= 0 || !this.selectedSegment || this.selectedSegment.length <= 0 || !this.selectedStartAwardYear || !this.selectedEndAwardYear) {
      if (!this.selectedStatus) this.status.validationStatus = "invalid";
      if (!this.selectedCompetitor) this.competitors.validationStatus = "invalid";
      if (!this.selectedSegment) this.segments.validationStatus = "invalid";
      if (!this.selectedStartAwardYear) this.startAwardYear.validationStatus = "invalid";
      if (!this.selectedEndAwardYear) this.segments.validationStatus = "invalid";
      return;
    }
    this.asuAndHYCOInvestmentFilters = new AsuSmrReportFilters(this.selectedStartAwardYear, this.selectedEndAwardYear, this.selectedStatus, this.selectedCompetitor, this.selectedSegment)
    switch (this.selectedReportLinkId) {
      case 1:
        this.asuSmrDetailsComponent.getASUAndHYCOInvestmentDetailsReportData(this.asuAndHYCOInvestmentFilters);
        break;
      default:
        this.asuSmrChartsComponent.getASUAndHYCOInvestmentReportData(this.asuAndHYCOInvestmentFilters);
        break;
    }
  }
}
